(function onDemandTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};

  const previousOnDemandTracker = global.NewHomeSource.Analytics.OnDemandTracker;
  const configurations = {
    hasBeenAttached: false
  };

  /**
   * @constructs NewHomeSource.Analytics.onDemandTracker;
   *
   * @param {IdleQueue} eventsQueue that runs the tasks on idle periods.
   * @param {Array} handlers that will react to the impression tracking.
   */
  function OnDemandTracker(eventsQueue, handlers) {
    configurations.queue = eventsQueue;
    configurations.handlers = [];

    const totalHandlers = handlers.length;

    for (let index = 0; index < totalHandlers; index += 1) {
      if (handlers[index] &&
        typeof handlers[index].onDemandTracker === 'function') {
        configurations.handlers.push(handlers[index]);
      }
    }

    configurations.totalHandlers = configurations.handlers.length;
  }

  /**
   * @public
   * init: creates a new MutationObserver to observe changes in the body of the document.
   * Sets up a listener in the document.body for on demand events.
   */
  OnDemandTracker.init = function init() {
    if (configurations.hasBeenAttached) {
      return;
    }

    configurations.hasBeenAttached = true;

    document.body.addEventListener('trackOnDemandEvent', (event) => {
      for (let index = 0; index < configurations.totalHandlers; index += 1) {
        const handler = configurations.handlers[index].onDemandTracker;
        const validator = configurations.handlers[index].onDemandTrackerValidator;
        if (typeof validator === 'function' && event.detail && validator(event.detail.data)) {
          configurations.queue.pushTask(handler.bind(event.detail.data));
        }
      }
    });
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Analytics.onDemandTracker to the previous script.
   */
  OnDemandTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.onDemandTracker = previousOnDemandTracker;
    return OnDemandTracker;
  };

  global.NewHomeSource.Analytics.onDemandTracker = OnDemandTracker;
}(window));
